module.exports = __webpack_public_path__ + "static/media/GuidedTicketResolver.cb299be8.png";